import { merge } from 'lodash-es';
import {
  ssnOrVaFileNumberNoHintSchema,
  ssnOrVaFileNumberNoHintUI,
  serviceNumberSchema,
  serviceNumberUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validations } from '../../validations';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['veteran-id-title'], content['veteran-id-description']),
    veteranSocialSecurityNumber: merge({}, ssnOrVaFileNumberNoHintUI(), {
      vaFileNumber: {
        'ui:title': content['veteran-id-file-number'],
      },
      ssn: {
        'ui:validations': [validations.isSsnDuplicated],
      },
    }),
    veteranServiceNumber: serviceNumberUI(content['veteran-id-service-number']),
  },
  schema: {
    type: 'object',
    required: ['veteranSocialSecurityNumber'],
    properties: {
      veteranSocialSecurityNumber: ssnOrVaFileNumberNoHintSchema,
      veteranServiceNumber: serviceNumberSchema,
    },
  },
};
